import { create } from "zustand";
import { devtools } from "zustand/middleware";

export interface Depth {
  depthName: string;
  depthNameOption?: string;
  depthIndex: number;
  listType:
    | "library"
    | "project"
    | "projectFlows"
    | "reports"
    | "folders"
    | "publish";
  id?: string[]; // 리스트 조회를 위해 필요한 id...
}

const usePageStore = create(
  devtools((set: any) => ({
    isPage: "",
    serviceUnavailable: false,
    isDetail: false,
    listViewType: "list",
    listDepthList: [] as Depth[],
    listRerenderTrigger: 0,
    selectedListDepth: {},
    searchResetTrigger: 0,
    selectedRowList: [] as any[], // GridList checkbox로 선택한 리스트
    setIsPage: async (page: string) => {
      set({ isPage: page });
    },
    setServiceUnavailable: async (value: boolean) => {
      set({ serviceUnavailable: value });
    },
    setIsDetail: async (isDetail: boolean) => {
      set({ isDetail: isDetail });
    },
    setListViewType: (value: "list" | "grid") => set({ listViewType: value }),
    setListDepthList: (value: Array<Depth>) => {
      set({ listDepthList: value, isDetail: value.length > 1 });
    },
    setSelectedListDepth: (value: Depth) => {
      set({ selectedListDepth: value });
    },
    setSearchResetTrigger: () => {
      set((state: any) => {
        return { searchResetTrigger: state.searchResetTrigger + 1 };
      });
    },
    setListRerenderTrigger: () => {
      set((state: any) => {
        return { listRerenderTrigger: state.listRerenderTrigger + 1 };
      });
    },
    setSelectedRowList: (selectedRowList: any[]) => {
      set({ selectedRowList });
    },
  }))
);

export default usePageStore;
